import React from 'react';

export default class CollectJSSection extends React.Component {
  // Created the 3 divs for the CollectJS iframes

  constructor(props){
    super(props);
    this.styling = {
      boxShadow: '0px 1px 2px 1px rgb(105 105 105 / 45%)',
      borderRadius: '10px'
    }
  }

  render() {
    return (
      <React.Fragment>
        <div style={{marginBottom: '15px', ...this.styling}} id="ccnumber" />
        <div>
          <div style={{width: '45%', float: 'left', ...this.styling}} id="ccexp" />
          <div style={{width: '45%', float: 'right', ...this.styling}} id="cvv" />
          <div style={{clear: 'both'}}></div>
        </div>
        
      </React.Fragment>
    );
  }
}
